export const CommonChallenges = () => {
  const challenges = [
    {
      icon: 'ri-store-fill',
      title: 'Vacant Commercial Space',
      problem: 'Ground floor retail or commercial spaces sitting vacant, reducing income and property value.',
      solution: 'We buy properties with vacant commercial space and have the expertise to re-lease or reposition them.'
    },
    {
      icon: 'ri-team-fill',
      title: 'Complex Management',
      problem: 'Managing different tenant types with varied needs, hours, and lease structures is overwhelming.',
      solution: 'We have professional management teams experienced with mixed-use properties and diverse tenant bases.'
    },
    {
      icon: 'ri-money-dollar-circle-fill',
      title: 'Below-Market Commercial Rents',
      problem: 'Commercial tenants on long-term leases at below-market rates, limiting income potential.',
      solution: 'We factor in current leases and future potential, providing fair offers that account for lease situations.'
    },
    {
      icon: 'ri-tools-fill',
      title: 'Deferred Maintenance',
      problem: 'Building systems, facades, or tenant spaces need significant capital investment.',
      solution: 'We specialize in properties needing work and have the capital to handle major improvements.'
    },
    {
      icon: 'ri-building-fill',
      title: 'Zoning Complexity',
      problem: 'Zoning issues, use restrictions, or compliance challenges creating uncertainty.',
      solution: 'We have experience navigating zoning and regulatory issues for mixed-use properties.'
    },
    {
      icon: 'ri-group-fill',
      title: 'Partnership Disputes',
      problem: 'Co-owners disagree on property management, tenant mix, or exit strategy.',
      solution: 'We can structure transactions to buy out partners or acquire the entire property cleanly.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Common Mixed-Use Property Challenges
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Mixed-use properties often come with unique challenges. We have the expertise and resources to handle any situation.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {challenges.map((challenge, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300">
              <div className="flex items-start mb-6">
                <div className="w-14 h-14 flex items-center justify-center bg-red-500 text-white rounded-lg mr-4 flex-shrink-0">
                  <i className={`${challenge.icon} text-2xl`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">{challenge.title}</h3>
              </div>
              <div className="mb-6">
                <h4 className="font-semibold text-red-600 mb-2">The Challenge:</h4>
                <p className="text-gray-600 leading-relaxed">{challenge.problem}</p>
              </div>
              <div className="border-t border-gray-200 pt-6">
                <h4 className="font-semibold text-teal-600 mb-2">Our Solution:</h4>
                <p className="text-gray-700 leading-relaxed">{challenge.solution}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-2xl p-8 md:p-12 text-white text-center">
          <h3 className="text-3xl font-bold mb-6">Facing One of These Challenges?</h3>
          <p className="text-xl mb-8 text-white/95 max-w-3xl mx-auto leading-relaxed">
            Don't let property challenges prevent you from moving forward. We've successfully acquired hundreds of mixed-use properties with complex issues. Let us provide a solution for your situation.
          </p>
          <a 
            href="#get-offer" 
            className="whitespace-nowrap inline-block bg-white text-teal-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
          >
            Discuss Your Situation
          </a>
        </div>
      </div>
    </section>
  );
};